import { render, staticRenderFns } from "./showQRCode.vue?vue&type=template&id=36724d0f&scoped=true"
import script from "./showQRCode.vue?vue&type=script&lang=js"
export * from "./showQRCode.vue?vue&type=script&lang=js"
import style0 from "./showQRCode.vue?vue&type=style&index=0&id=36724d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36724d0f",
  null
  
)

export default component.exports